import r from "../helpers/isAbsoluteURL.es.js";
import f from "../helpers/combineURLs.es.js";
function u(l, i, t) {
  let o = !r(i);
  return l && (o || t == !1) ? f(l, i) : i;
}
export {
  u as default
};
